export const MILLWRIGHTS_ROUTE = '/millwrights';

export const MILLWRIGHT_ROUTE = '/millwrights/:millwrightId';
